/* eslint-disable react/prop-types */
import * as React from 'react';

const SvgComponent = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={24.656} height={17.778} {...props}>
    <g data-name="Group 384">
      <g data-name="Icon feather-user">
        <path
          data-name="Path 312"
          fill={props.fill ? props.fill : '#f000'}
          d="M15.111 17.778a.889.889 0 0 1-.889-.889v-1.778a2.67 2.67 0 0 0-2.667-2.667H4.444a2.667 2.667 0 0 0-2.667 2.667v1.778a.889.889 0 1 1-1.778 0v-1.778a4.444 4.444 0 0 1 4.445-4.444h7.111A4.449 4.449 0 0 1 16 15.111v1.778a.889.889 0 0 1-.889.889Z"
        />
        <path
          data-name="Path 313"
          fill={props.fill ? props.fill : '#f000'}
          d="M8 0a4.444 4.444 0 1 1-4.444 4.444A4.449 4.449 0 0 1 8 0Zm0 7.111a2.667 2.667 0 1 0-2.667-2.667A2.67 2.67 0 0 0 8 7.111Z"
        />
      </g>
      <path
        data-name="Path 738"
        fill={props.fill ? props.fill : '#f000'}
        d="M24.656 10.461h-3.2v3.228H19.68v-3.228H16.5v-1.68h3.18V5.533h1.776v3.248h3.2Z"
      />
    </g>
  </svg>
);

export default SvgComponent;



// WEBPACK FOOTER //
// src/assets/UserPlus.jsx